// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    contentful: {
        accessToken: "CFPAT-LETSL3tLt9WQ-8a-7NG0SPHS4PuD2lZx8T1gwDsQRM0",
        spaceId: "inqmqrszajug",
        environmentId: "master",
        space: "inqmqrszajug",
        environment: "master",
        managementToken: "CCFPAT-6iFMVS0eIKxfefh_OMaaDT4UMKwD4550SKnIXQyhoPs",
        counterId: "KkDr1fSPli6TETUewyg1z",
    },
    emailJs: {
        serviceId: "service_2r7qa3d",
        loginTemplateId: "template_5t2cuy2",
        confirmationTemplateId: "template_7jvidkv",
        publicKey: "WiaZvYNXTqqST64y7",
    },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
